export default {fields:{authors:{spreads:{Author:{}}}}}